import React, {useEffect, useState} from 'react'
import {Link, NavLink, Route, Routes, useLocation} from 'react-router-dom'
import axios from 'axios'

import {toast, ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import smoothscroll from 'smoothscroll-polyfill'

import NotFound from './universalyComponents/notFound/NotFound'
import {
  Jobs,
  Listing,
  Main,
  PrivacyPolicy,
  CookiePolicy,
  Relocation,
  Education,
  InternShips,
  Mirea,
  FormVacationPopup,
  AcceptPolicy,
  Media
} from './components/pages'
import {Footer, Header, Cookie} from './components/basicUI'
//import FormVacationPopup from './components/pages/form/FormVacationPopup/FormVacationPopup'

import PopupForInternShips from './components/pages/popupForInternShips/PopupForInternShips'

import styles from './App.module.scss'
import Job from './components/pages/jobs/Job'

const _domenWork = 'career.generium.ru'
const _captchaSiteKey = 'ysc1_U9ngjEJRDCtkQAiRhqD8osoNQHONUt7TQFe1UO2e7d38e2a6';

function App() {
  smoothscroll.polyfill()
  const location = useLocation()
  const prevRoute = location?.state
  const userId = prevRoute?.itemVacation?.id

  const [activeButton, setActiveButton] = useState(false)
  const [activeForm, setActiveForm] = useState(false)
  const [successForm, setSuccessForm] = useState(false)
  const [successForm2, setSuccessForm2] = useState(false)
  const [retake, setRetake] = useState(false)
  const [filterVacation, setFilterVacation] = useState([])
  const [listAdvantage, setListAdvantageMain] = useState([])
  const [searchMainInput, setSearchMainInput] = useState('')
  const [ourRef, setOurRef] = useState('')
  const [activePopUp, setActivePopUp] = useState(false)

  //const [checkDomenNameState, setCheckDomenNameState] = useState('')
  let checkDomenNameState = ''
  let _protocol = window.location.protocol
  const [infoVacationRetakePage, setInfoVacationRetakePage] = useState({})

  const uploadForm = () => {
    setActiveForm(false)
    setSuccessForm(false)
    setSuccessForm2(false)
    setRetake(false)
  }

  // const checkDomen = () => {
  //   if (window.location.hostname === _domenWork) {
  //     setCheckDomenNameState(window.location.hostname)
  //   } else {
  //     setCheckDomenNameState('')
  //   }
  // }
  if (window.location.hostname.indexOf(_domenWork) != -1) {
    checkDomenNameState = window.location.hostname
  }

  // Получение последних 6 вакансий
  const filterPositionVacation = async () => {
    const totalPage = {
      page: 0,
      size: 6,
      sort: ['updateDate']
    }

    try {
      if (checkDomenNameState) {
        const result = await axios({
          method: 'post',
          url: `${_protocol}//${checkDomenNameState}/api/v1/position`,
          data: totalPage
        })
        setFilterVacation(result.data.content)
      }
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }

  useEffect(() => {
    //checkDomen()
    checkDomenNameState && filterPositionVacation()
  }, [checkDomenNameState])

  // Получение преимуществ на главную
  const listAdvantageMain = async () => {
    try {
      if (checkDomenNameState) {
        const result = await axios({
          method: 'post',
          url: `${_protocol}//${checkDomenNameState}/api/v1/advantage/main`,
        })
        setListAdvantageMain(result.data)
      }
    } catch (e) {
      toast.error('Ошибка загрузки вакансий')
    }
  }
  useEffect(() => {
    //checkDomen()
    checkDomenNameState && listAdvantageMain()
  }, [checkDomenNameState])

  return (
    <div className={styles.app}>
      <Header
        setActiveForm={setActiveForm}
        setOurRef={setOurRef}
        setActivePopUp={setActivePopUp}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
      <div className="layout_content">
        <div onClick={() => setActiveButton(false)}>
          <Routes>
            <Route
              path='/'
              element={
                <Main
                  filterVacation={filterVacation}
                  listAdvantage={listAdvantage}
                  setSearchMainInput={setSearchMainInput}
                  searchMainInput={searchMainInput}
                  ourRef={ourRef}
                  checkDomenNameState={checkDomenNameState}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            />
            <Route path='/privacy-policy' element={<PrivacyPolicy ourRef={ourRef} />}/>
            <Route path='/cookie-policy' element={<CookiePolicy ourRef={ourRef} />}/>
            <Route
              path='/listing/jobs/*'
              element={
                <Job
                  filterVacation={filterVacation}
                  setFilterVacation={setFilterVacation}
                  ourRef={ourRef}
                  setActiveForm={setActiveForm}
                  checkDomenNameState={checkDomenNameState}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            >
              <Route path={':' + userId} element={<Jobs captchaSiteKey={_captchaSiteKey} />}/>
            </Route>
            <Route
              path='/relocation'
              element={
                <Relocation 
                  filterVacation={filterVacation} 
                  ourRef={ourRef}
                  checkDomenNameState={checkDomenNameState}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            />
            <Route 
              path='/students/education' 
              element={
                <Education 
                  ourRef={ourRef} 
                  setActivePopUp={setActivePopUp}
                  checkDomenNameState={checkDomenNameState}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            />
            <Route
              path='/students/internShips'
              element={
                <InternShips 
                  checkDomenNameState={checkDomenNameState} 
                  ourRef={ourRef} 
                  setActivePopUp={setActivePopUp} 
                  captchaSiteKey={_captchaSiteKey} 
                />
              }
            />
            <Route
              path='/students/mabstudy'
              element={<Mirea ourRef={ourRef} checkDomenNameState={checkDomenNameState} captchaSiteKey={_captchaSiteKey} />}
            />
            <Route
              path='/listing'
              element={
                <Listing
                  successForm={successForm}
                  filterVacation={filterVacation}
                  searchMainInput={searchMainInput}
                  setSearchMainInput={setSearchMainInput}
                  ourRef={ourRef}
                  checkDomenNameState={checkDomenNameState}
                  setInfoVacationRetakePage={setInfoVacationRetakePage}
                  infoVacationRetakePage={infoVacationRetakePage}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            />
            <Route
              path='/accept-policy/'
              element={
                <AcceptPolicy
                  checkDomenNameState={checkDomenNameState}
                  setCheckRef={setOurRef}
                  captchaSiteKey={_captchaSiteKey}
                />
              }
            />
            <Route 
              path='/media' 
              element={<Media ourRef={ourRef} />} 
            />
            <Route path='*' element={<NotFound/>}/>
          </Routes>
        </div>

        {activePopUp && (
          <PopupForInternShips
            setActivePopUp={setActivePopUp}
            checkDomenNameState={checkDomenNameState}
            retake={retake}
            setRetake={setRetake}
            captchaSiteKey={_captchaSiteKey}
          />
        )}
        {activeForm && !activePopUp && (
          <div className={styles.wrapper_total_down}>
            <div className={styles.wrapper_total_left} onClick={() => setRetake(true)}></div>
            <div className={styles.wrapper_total_right}>
              <div>
                <p className={styles.wrapper_total_right_p1} onClick={() => setRetake(true)}>
                  <span>&larr;</span>Вернуться назад
                </p>
                {retake && (
                  <div className={styles.retake_wrapper}>
                    <p className={styles.retake_wrapper_p1}>Закрыть форму?</p>
                    <p className={styles.retake_wrapper_p2}>
                      Вы начали заполнять форму отклика на вакансию. Если ее закрыть, то заполненные поля не сохранятся.
                    </p>
                    <div className={styles.retake_wrapper_btn}>
                      <button className={styles.retake_wrapper_btn_1} onClick={() => setRetake(false)}>
                        Остаться
                      </button>
                      <Link
                        className={styles.retake_wrapper_btn_2}
                        onClick={uploadForm}
                        to={!prevRoute ? '/' : prevRoute}
                        state={prevRoute}
                      >
                        Закрыть форму
                      </Link>
                    </div>
                  </div>
                )}
                <p className={styles.wrapper_total_right_p2}>Хотите работать с нами?</p>
                <div className={styles.wrapper_total_text}>
                  <p className={styles.wrapper_total_text_p2}>
                    <span>→</span> Заполните эту форму
                  </p>
                </div>

                {successForm && (
                  <div className={styles.wrapper_total_right_success}>
                    <p className={styles.wrapper_total_right_success_p1}>
                      Спасибо за интерес <br/> к&nbsp;компании Generium!
                    </p>
                    <p>Мы свяжемся с вами в случае соответствия требованиям вакансии.</p>
                    <NavLink onClick={uploadForm} to='/' className={styles.wrapper_total_right_success_btn}>
                      Вернуться на главную <span>→</span>
                    </NavLink>
                  </div>
                )}
                {successForm2 && (
                  <div className={styles.wrapper_total_right_success}>
                    <p className={styles.wrapper_total_right_success_p1}>
                      Спасибо за интерес <br/> к&nbsp;компании Generium!
                    </p>
                    <p>Мы свяжемся с вами в случае соответствия резюме требованиям вакансии.</p>
                    <NavLink onClick={uploadForm} to='/' className={styles.wrapper_total_right_success_btn}>
                      Вернуться на главную <span>→</span>
                    </NavLink>
                  </div>
                )}
              </div>

              {/*  form block */}
              {!successForm2 && (
                <FormVacationPopup
                  setSuccessForm2={setSuccessForm2}
                  setActiveForm={setActiveForm}
                  checkDomenNameState={checkDomenNameState}
                  captchaSiteKey={_captchaSiteKey}
                />
              )}
            </div>
          </div>
        )}
        <ToastContainer
          position='bottom-left'
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Cookie />
        <Footer
          ourRef={ourRef}
          setSearchMainInput={setSearchMainInput}
          searchMainInput={searchMainInput}
          setActivePopUp={setActivePopUp}
        />
      </div>
    </div>
  )
}

export default App
